angular.module('invoice')
    .service('KsefAssignmentRuleModalService', function (modals) {
        this.open = data => modals.open('app/invoice/ksef/assignment-rule-modal.html', 'KsefAssignmentRuleModalController', data, {size: 'md'}, '$ctrl')
    })
    .controller('KsefAssignmentRuleModalController', function ($uibModalInstance, data, InvoiceAssignmentRule, toastr) {
        this.ruleModes = ['FIXED', 'ROUND_ROBIN', 'LEAST_LOADED']
        this.mode = data?.mode || 'create'
        this.isGlobalRulesView = !!data?.isGlobalRulesView
        this.isAllRulesView = !!data?.isAllRulesView
        this.buyerId = data?.buyerId || null
        this.buyer = data?.buyer || null

        this.$onInit = () => {
            this.form = angular.copy(data?.rule || {})
            this.form.assignMode = this.form.assignMode || 'ROUND_ROBIN'
            this.form.confidential = !!this.form.confidential
            this.form.addRuleUsersToWorkflow = !!this.form.addRuleUsersToWorkflow
            this.form.users = angular.copy(this.form.users || [])
            this.form.accessGroups = angular.copy(this.form.accessGroups || [])
            this.form.sourceType = this.form.sourceType || 'KSEF'
            this.form.scope = this.form.scope || 'GLOBAL'
            if (!this.isGlobalRulesView && !this.isAllRulesView && !this.form?.id && this.buyerId) {
                this.form.buyer = {id: this.buyerId}
            }
        }

        this.title = () => {
            if (this.mode === 'edit' && this.form?.id) {
                return 'Edycja reguły'
            }
            if (this.mode === 'duplicate') {
                return 'Powiel regułę dla spółki'
            }
            return 'Nowa reguła'
        }

        this.targetLabel = () => {
            if (this.isGlobalRulesView) {
                return 'Globalna'
            }
            if (this.form?.buyer?.id) {
                return 'Spółka'
            }
            return 'Globalna'
        }

        this.save = () => {
            let payload = angular.copy(this.form)
            if (this.isGlobalRulesView) {
                payload.buyer = null
            } else if (this.isAllRulesView) {
                payload.buyer = payload?.buyer?.id ? {id: payload.buyer.id} : null
            } else if (payload.id && !(payload.buyer && payload.buyer.id)) {
                payload.buyer = null
            } else {
                payload.buyer = {id: this.buyerId}
            }
            payload.sourceType = payload.sourceType || 'KSEF'
            payload.scope = payload.scope || 'GLOBAL'
            payload.active = true

            let request = payload.id
                ? InvoiceAssignmentRule.update({id: payload.id}, payload).$promise
                : InvoiceAssignmentRule.save(payload).$promise

            return request.then(() => {
                toastr.success('Zapisano regułę')
                $uibModalInstance.close('saved')
            })
        }

        this.isFixedMultiInvalid = () => {
            return this.form?.assignMode === 'FIXED' && this.form?.users && this.form.users.length > 1
        }

        this.isUsersRequiredInvalid = () => {
            return !this.form?.users || this.form.users.length === 0
        }

        this.isConfidentialGroupsInvalid = () => {
            return !!this.form?.confidential && (!this.form.accessGroups || this.form.accessGroups.length === 0)
        }

        this.isSaveDisabled = () => {
            return !this.form?.assignMode || this.isFixedMultiInvalid() || this.isUsersRequiredInvalid() || this.isConfidentialGroupsInvalid()
        }

        this.onConfidentialChanged = () => {
            if (!this.form?.confidential) {
                this.form.accessGroups = []
            }
        }

        this.onAssignModeChanged = () => {
            if (this.form?.assignMode === 'FIXED' && this.form?.users && this.form.users.length > 1) {
                this.form.users = [this.form.users[0]]
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
    })
